<template lang="html">
  <div class="dashboard">
    <TopBar/>
    <SideBar/>
    <router-view></router-view>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar';
import TopBar from '@/components/TopBar';

export default {
  data() {
    return {
      drawer: false,
    }
  },
  components: {
    TopBar,
    SideBar,
  }
}
</script>

<style lang="scss" scoped>

#main {
  &.anim {
    &-enter {
      transform: translateY(50px);
      opacity: 0;
    }
    &-enter-to {
      transform: translateY(0);
      opacity: 1;
    }
    &-leave-active {
      display: none;
    }
    &-enter-active {
      transition: transform 0.5s ease, opacity 0.5s ease;
    }
  }
}

</style>
